import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';

import { switchMap, first, take, map } from "rxjs/operators";


import { combineLatest } from 'rxjs/observable/combineLatest';


@Injectable({
  providedIn: 'root'
})
export class OfficeService {

  constructor(private afs: AngularFirestore) { }

  async getShopById(uid: string){
    try{
        let aux = await this.afs.collection("shops", 
            ref => ref.where('uid', '==', uid)
                      .where('delete', '==', false))
                      .valueChanges().pipe(first()).toPromise().then(doc => {
                          return doc;
                      }).catch(error => {
                          throw error;
                      });
        if(aux.length==0)
            return {};
        return aux[0];
    }catch(error){
      console.error("Error getOfficeById", error);
      throw error;
    } 
  }

  /**
   * Retornar un objeto obervable de una oficina 
   * @param uid Identificador de la oficina o local buscado
   */
  getOffice(uid:string){
    return this.afs.doc<any>(`offices/${uid}`).valueChanges();
  }

  async getOfficeById(uid: string){
    try{
        let aux = await this.afs.collection("offices", 
            ref => ref.where('uid', '==', uid)
                      .where('delete', '==', false))
                      .valueChanges().pipe(first()).toPromise().then(doc => {
                          return doc;
                      }).catch(error => {
                          throw error;
                      });
        if(aux.length==0)
            return {};
        return aux[0];
    }catch(error){
      console.error("Error getOfficeById", error);
      throw error;
    } 
  }

  getOffices(){
    try{
        let aux1 = this.afs.collection("offices", 
            ref => ref.where('uid', '<', 'base')
                      .where('active', '==', true)
                      .where('delete', '==', false))
                      .valueChanges();
        let aux2 = this.afs.collection("offices", 
            ref => ref.where('uid', '>', 'base')
                .where('active', '==', true)
                .where('delete', '==', false))
                .valueChanges();

        const combinedList = combineLatest<any[]>(aux1, aux2).pipe(
            map(arr => arr.reduce((acc, cur) => acc.concat(cur))),
            map(items => items.sort(this.sortByName))
        )
            
        return combinedList;
    }catch(error){
      console.error("Error getOfficeById", error);
      throw error;
    } 

  }

  sortByName(a, b) {
    if ((a.shop.name + a.alias) < (b.shop.name + b.alias)) { return 1; }
    if ((a.shop.name + a.alias) > (b.shop.name + b.alias)) { return -1; }
    return 0;
  }

  async updateDataOffice(uid:string, data: any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `offices/${uid}`
    );
    return await userRef.set(data, { merge: true }); 
  }
  
}
